/* RESPONSIBLE TEAM: team-standalone */
import StepSerializer from '../step';

export default StepSerializer;
